import request from '@/utils/request'
// const server = "/cloudhealth-server-portal"
import Vue from 'vue'
// const server = Vue.prototype.portal
const server = "/business";

//查询危险因素
// export function getLatestRiskFactors(reqParam) {
//   return request({
//     url: server+'/healthinfo/getLatestRiskFactors',
//     method: 'post',
//     data: reqParam
//   })
// }

export function getLatestRiskFactors(reqParam) {
  return request({
    url: server+'/patientHealthParam/listHealthParams',
    method: 'post',
    data: reqParam
  })
}

//获取最新指标
export function getAssessmentRiskParams(pid) {
    return request({
      url: server+'/healthinfo/getAssessmentRiskParams',
      method: 'get',
      params: {patientId:pid}
  })
}

//获取指定患者的最新的所有病种的评估
export  function getPatientLatestAssessment(patientIdStr) {
  return request({
   url: server+'/healthinfo/getLatestAssessments',
   method: 'get',
   params: {patientId:patientIdStr}
 })
}

//系统内所有的评估类型
export  function getRiskAssessmentTypes() {
  return request({
   url: server + '/healthinfo/getRiskAssessmentTypes',
   method: 'get',
   params: {}
 })
}

//获取老年评估最新报告
export  function getLatestElderEvalReport(patientIdStr) {
  return request({
   url: server+'/healthinfo/getLatestElderEvalReport',
   method: 'get',
   params: {patientId:patientIdStr}
 })
}

//获取老年评估报告列表
export function getElderEvalReports(reqParam) {
  return request({
    url: server+'/healthinfo/getElderEvalReports',
    method: 'post',
    data: reqParam
  })
}

//获取老年评估报告详情
export  function getElderEvalDetail(reqParam) {
  return request({
   url: server+'/healthinfo/getElderEvalDetail',
   method: 'get',
   params: reqParam
 })
}

//获取营养评估
export function getMedicalRecords(reqParam) {
  return request({
    url: server+'/healthinfo/medicalrecord/getMedicalRecords',
    method: 'get',
    params: reqParam
  })
}

//获取营养评估详情
export  function getMedicalRecordDetail(reqParam) {
  return request({
   url: server+'/healthinfo/medicalrecord/getMedicalRecordDetail',
   method: 'get',
   params: reqParam
 })
}

//获取营养评估详情
export  function getRiskParamEnum() {
  return request({
   url: server+'/healthinfo/getRiskParamEnum',
   method: 'get',
   params: {}
 })
}

//删除模型评估
export function removePersonalModels(reqParam) {
  return request({
    url: server+'/healthinfo/removePersonalModels',
    method: 'post',
    data: reqParam
  })
}

//删除患者用药
export function removePersonalMedicines(reqParam) {
  return request({
    url: server+'/healthinfo/removePersonalMedicines',
    method: 'post',
    data: reqParam
  })
}

//删除患者诊断
export function removePersonalDiags(reqParam) {
  return request({
    url: server+'/healthinfo/removePersonalDiags',
    method: 'post',
    data: reqParam
  })
}

//添加模型评估
export function addPersonalModels(reqParam) {
  return request({
    url: server+'/healthinfo/addPersonalModels',
    method: 'post',
    data: reqParam
  })
}

//获取模型匹配危险因素
export  function getRiskFactorsByAssessment(reqParam) {
  return request({
   url: server+'/healthinfo/getRiskFactorsByAssessment',
   method: 'get',
   params: reqParam
 })
}

//编辑模型评估
export function updatePersonalModel(reqParam) {
  return request({
    url: server+'/healthinfo/updatePersonalModel',
    method: 'post',
    data: reqParam
  })
}

//高血压评估
export function getDiagnosisHypertension() {
  return request({
    url: server+'/es/diagnosis/hypertension',
    method: 'post',
    data: {}
  })
}